import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AbstractSubmissionReceipt from '@/components/reviewSubmission/AbstractSubmissionReceipt.vue'
    import MainTemplate from '@/components/MainTemplate.vue'
    import { useRoute } from 'vue-router'
    import router from '@/router'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'NetworkErrorSubmission',
  setup(__props) {

    const route = useRoute()
    const handleReturnConfirmation = () => {
        router.push({ name: 'FNOL Review and Submission', params: { visible: 'true' }, query: { data: route.query.data } })
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MainTemplate, null, {
    default: _withCtx(() => [
      _createVNode(AbstractSubmissionReceipt, {
        class: "self",
        header: 'termsAndConditions.reviewSubmission.networkError.header',
        reason: 'termsAndConditions.reviewSubmission.networkError.reason',
        title: 'termsAndConditions.reviewSubmission.networkError.title'
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", { onClick: handleReturnConfirmation }, _toDisplayString(_ctx.$t('termsAndConditions.reviewSubmission.networkError.highLight')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})